import {
    CmpsScorecardPillarInformationData,
    CmpsScoreSectionData,
    CmpsScoreSectionMenuData,
    CmpsScoreSectionTrendData,
    RankBonusViewModel,
} from '@cmps/ng-kit';

import { HeaderRowData } from '../card--my-coaching-card/models/header-row-data.model';

import { ScCategory } from './models/sc-category.model';
export interface ScorecardData {
    headerRowData?: HeaderRowData;
    scorecardSubHeader?: ScorecardSubHeader;
    adjustScoreData?: CmpsScoreSectionData;
    originalScoreData?: CmpsScoreSectionData;
    trendData?: CmpsScoreSectionTrendData;
    dropdownMenuData?: CmpsScoreSectionMenuData;
    scorecardPillarInformationData?: CmpsScorecardPillarInformationData[];
    rankData?: RankBonusModel;
    bonusData?: RankBonusModel;
    scCategory?: ScCategory;
}

export interface ScorecardSubHeader {
    supergroupLabel?: string;
    scorecardId: string;
    supergroupValue?: string;
    scorecardValue: string;
    isDisabled?: boolean;
}

export enum MenuItems {
    'LAUNCH_SCORECARD' = 1,
    'TREND',
    'ADD_RANK',
    'ADD_BONUS',
}
export interface RankBonusModel {
    isVisible: boolean;
    titleLabel: string;
    data: RankBonusViewModel[];
}
export interface PillarData {
    pillarId: number;
    pillarValue: number;
    displayOrder: number;
}
